import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContractService } from '../services/contract.service';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.scss']
})
export class ContractListComponent implements OnInit, OnDestroy {
  public accessRoles: any;
  public scrollDistance = 2;
  public throttle = 10;
  public searchValue = "";
  constructor(
    private router: Router,
    public contractService: ContractService
  ) { 
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.contractService.headerSearchEventEmitter.subscribe((searchValue: string) => {
      this.onSearchChange(searchValue);
    });
  }

  ngOnInit(): void {
    this.contractService.isGlobalSearchShow = true;
    this.contractService.getContractListData();
  }

  ngOnDestroy(): void {
    this.contractService.isGlobalSearchShow = false;
  }

  onSearchChange(str){
    this.searchValue = str;
    if(this.searchValue.length > 1){
      let query = {};
      query['search'] = this.searchValue;
      query['page'] = 1;
      this.contractService.contractListData = [];
      this.contractService.getContractListData(query);
    }else{
      this.contractService.getContractListData({page:1});
    }
  }

  createContract(){
    this.contractService.backTrack = "contract-list";
    this.router.navigate(['/contract/request']);
  }

  getDynamicStyleHeader(){
    return this.contractService.contractListHeader.map(() => '1fr').join(' ') + ' 1fr';
  }

  onScroll(){
    if( this.contractService.contractListPage == 1 || this.contractService.contractListPage < this.contractService.contractListTotalPage){
      this.contractService.contractListPage++;
      let query = {};
      if (this.searchValue && this.searchValue != "") {
        query['search'] = this.searchValue;
      }
      query['page'] = this.contractService.contractListPage;
      this.contractService.getContractListData(query);
    }
  }

  // viewDetails(uuid){
  //   this.contractService.contractSaveId = uuid;
  //   this.contractService.backTrack = "contract-list";
  //   if (this.accessRoles.access_rules && this.accessRoles.access_rules.contract && this.accessRoles.access_rules.contract.signed) {
  //     this.router.navigate(['/contract/preview/'+uuid]);
  //   }else{
  //     this.router.navigate(['/contract/details/'+uuid]);
  //   }
  // }
    viewDetails(data){
      this.contractService.contractSaveId = data['uuid'];
      this.contractService.backTrack = "contract-list";
      if (data && data['view_details']) {
        this.router.navigate(['/contract/details/'+data['uuid']]);
      }else{
        this.router.navigate(['/contract/preview/'+data['uuid']]);
      }
    }
}
